module.exports = __webpack_public_path__ + "IMG_8011.5c1fe086d425b5d8d7d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding/andy_jeska/600x600/IMG_8011.jpg
// module id = ./src/assets/images/wedding/andy_jeska/600x600/IMG_8011.jpg
// module chunks = main